require('intersection-observer');

class videoHelper{
	constructor() {
		
	}
	playInView(el) {
		if (window.matchMedia("(min-width: 769px)").matches) {
		let options  = {
			rootMargin: '0%',
			threshold: [.5]
		};
		let observer = new IntersectionObserver(this.inView, options);
		observer.observe(el);
		}
	}
	inView(entries, observer){

		// if (gyroPresent == true) {
			entries.forEach(entry => {
				console.log(entry);
				if (entry.isIntersecting) {
					// entry.target.setAttribute('autoplay');
					entry.target.play();
				} else {
					entry.target.pause();
				}
			});
		}
	// }
}
window.app.add('video', new videoHelper());